import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import PricingSelection from 'components/pricing/PricingSelectionComponent'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    width: 200
  }
})
class ChangeCurrentPricingModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    pricings: PropTypes.array.isRequired,
    currentPricing: PropTypes.object.isRequired,
    changeCurrentPricing: PropTypes.func.isRequired
  }
  state = {
    pricing: null,
    dateError: void 0,
    date: moment().format('HH:mm')
  }
  handleValidate = () => {
    const { pricing, date } = this.state
    if (pricing.key === this.props.currentPricing.key) {
      return
    }
    this.props.changeCurrentPricing(pricing, moment(date, 'HH:mm').format())
  }
  handleDateChange = e => {
    let error
    if (moment().isBefore(moment(e.target.value, 'HH:mm'))) {
      error = 'La date ne peut pas être dans le futur'
    }
    this.setState({ date: e.target.value, dateError: error })
  }
  handlePricingChange = pricing => {
    this.setState({ pricing: pricing })
  }
  componentWillMount() {
    if (this.props.currentPricing) {
      this.setState({ pricing: this.props.currentPricing })
    }
  }
  render() {
    const { pricings, classes } = this.props
    const { pricing, dateError } = this.state
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleValidate}
        title={`Changer le tarif en cours`}
        okDisabled={
          !pricing ||
          pricing.key === this.props.currentPricing.key ||
          !!dateError
        }
        showOk>
        <Grid container direction="row" justify="center">
          <Grid item xs={12}>
            <Typography variant="title" gutterBottom>
              {' '}
              Choix du tarif{' '}
            </Typography>
            <Divider />
          </Grid>
          <PricingSelection
            selectedPricing={pricing}
            pricings={pricings}
            onChange={this.handlePricingChange}
          />
          <TextField
            id="time"
            error={!!dateError}
            helperText={dateError || null}
            label="Heure du changement"
            type="time"
            onChange={this.handleDateChange}
            value={this.state.date}
            className={classes.textField}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              step: 60
            }}
          />
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(ChangeCurrentPricingModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/ChangeCurrentPricingModal.js